<script>
	export let toggleColor = '';
	export let toggleBackgroundColor = '';
	export let active = false;
</script>

<span class:active on:click
	  style="--toggle-color: {toggleColor}; --toggle-background-color: {toggleBackgroundColor}"
/>

<style lang="scss">
	@import "../../style/mixins";
	@import "../../style/variables";

		span {
			position: relative;
			width: 8.5rem;
			float: right;
			right: 0;
			height: var(--button-height);
			border-radius: calc(var(--button-height) / 2);
			background-color: var(--toggle-background-color, white);
			transition: color var(--animation-duration) ease-in-out, background-color var(--animation-duration) ease-in-out;

			&:before {
				content: "";
				width: calc(var(--button-height) - (var(--toggle-distance) * 2));
				height: calc(var(--button-height) - (var(--toggle-distance) * 2));
				display: block;
				background-color: var(--toggle-color, black);
				border-radius: 50%;
				position: absolute;
				top: var(--toggle-distance);
				left: var(--toggle-distance);
				transition: left var(--animation-duration) ease-in-out;
			}
		}

	span.active {
		background-color: var(--toggle-background-color-active, var(--toggle-background-color, white));
	}

	span.active:before,
	:global(.custom_css--active span:before) {
		left: calc(100% - var(--button-height) + var(--toggle-distance));
		background-color: var(--toggle-color-active, var(--toggle-color, black));
	}
</style>
